import React from "react"
import "../styles/homeHero.css"
import object from "../svgs/object1.svg"
import object1 from "../svgs/object2.svg"
import { getDownloadURL } from "firebase/storage"
import { getDoc, doc } from "firebase/firestore"
import { db, infoRef } from "../firebase"
import { SideName } from "./sideName"
import { useAbout } from "../contexts/aboutContext"
import { Link } from "react-router-dom"

export function HomeHero() {
  const [intro] = useAbout()

  return (
    <section className="home-hero" id="home">
      <div className="obj-1">
        <img src={object} alt="" srcset="" />
      </div>
      <small>Hi, my name is</small>
      <h2 className="display-1 text-capitalize fw-bold mt-2 mb-0 p-0 name">
        osaretin frank.
      </h2>
      <h3 className="display-2 fw-bold mt-0 p-0">
        I create things for the web.
      </h3>
      <p
        className="info mt-4 mb-5 mb-md-3"
        dangerouslySetInnerHTML={{ __html: intro }}
      ></p>
      <Link to="/portfolio" className="btn-custom mt-2">
        Explore ➜
      </Link>

      <div className="style"></div>
      <div className="style-2"></div>
    </section>
  )
}
